module.exports = __webpack_public_path__ + "img/11_58.496bd674.png";